import { reviews } from "@/mocks/homeData";

export default function ReviewsSection() {
  return (
    <section id="avis" className="py-16 md:py-24 bg-background-950">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="text-sm font-semibold tracking-wider text-primary-500 uppercase mb-2 block">
            Avis client
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-background-50 mb-4 font-heading tracking-wide">
            Ils partagent leur expérience
          </h2>
        </div>

        <div className="flex flex-col items-center mb-10">
          <div className="flex items-center gap-1 mb-2">
            {Array.from({ length: 5 }).map((_, i) => (
              <i
                key={i}
                className="ri-star-fill w-5 h-5 flex items-center justify-center text-accent-400 text-lg"
              />
            ))}
          </div>
          <p className="text-lg font-semibold text-background-50">
            4,3/5 sur Google
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {reviews.map((review, index) => (
            <div
              key={review.id}
              className={`bg-white border rounded-xl p-6 md:p-8 flex flex-col ${
                index === 1
                  ? "border-primary-500 ring-2 ring-primary-500/40 md:-translate-y-2"
                  : "border-background-200"
              }`}
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className="ri-star-fill w-4 h-4 flex items-center justify-center text-accent-400 text-base"
                  />
                ))}
              </div>

              <blockquote className="text-background-300 leading-relaxed italic flex-1">
                « {review.text} »
              </blockquote>

              <div className="mt-6 pt-5 border-t border-background-200 flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center text-primary-700 font-bold text-lg shrink-0">
                  {review.authorInitials}
                </div>
                <p className="font-semibold text-background-50 text-sm leading-snug">
                  {review.author}{" "}
                  <span className="font-normal text-background-300">
                    — Avis Google
                  </span>
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}